import * as yup from 'yup';
import { treasuryContributionFormFields } from '../../fields/formFields/treasuryContribution';
import { amountSchema } from '../common/amountSchema';

export const treasuryContributionSchema = yup.object({
  [treasuryContributionFormFields.amount]: amountSchema,
});
